import { FaArrowRightLong } from 'react-icons/fa6'
import { PropTypes } from 'prop-types'
import { Link, useNavigate } from 'react-router-dom'

const NextIntake = ({
  date,
  brochure,
  feeTable,
  scholarshipAndAidDownload
}) => {
  const day = new Date(date).getDate()
  const month = new Date(date).toLocaleDateString('default', { month: 'long' })
  const year = new Date(date).getFullYear()
  const navigate = useNavigate()

  const handleGo = () => {
    navigate('/admission')
  }

  return (
    <div className='w-full md:w-5/6 lg:w-max min-h-96  bg-white rounded-2xl border-2 border-stone-300 p-6 py-8 flex flex-col gap-3'>
      <div className=' flex flex-col mb-2'>
        <span className='text-slate-900 text-lg font-bold '>Next Intake:</span>
        <span className='text-slate-900 text-2xl font-bold '>{`${month} ${day}, ${year}`}</span>
      </div>
      <div className='flex flex-col gap-4'>
        <button
          onClick={handleGo}
          className='flex gap-1 text-center justify-center font-bold items-center p-2 px-3 2xl:text-[16px] 2xl:leading-7 rounded bg-[#9c0000] text-white w-full text-xs whitespace-nowrap'
        >
          Apply Now
          <FaArrowRightLong  className='ml-1 shrink-0'/>
        </button>
        <a
          href={brochure}
          target='_blank'
          rel='noreferrer'
          download={brochure}
          className='flex gap-1 text-center  justify-center font-bold items-center p-2 px-3 2xl:text-[16px] 2xl:leading-7 rounded bg-[#9c0000] text-white w-full text-xs sm:whitespace-nowrap'
        >
          Download Course Brochure
          <FaArrowRightLong  className='ml-1 shrink-0'/>
        </a>
        <a
          href={feeTable}
           target='_blank'
          rel='noreferrer'
          download={feeTable}
          className='flex gap-1 text-center   border border-blue-700 text-blue-700 justify-center font-bold items-center p-2 px-3 2xl:text-[16px] 2xl:leading-7 rounded  w-full text-xs sm:whitespace-nowrap'
        >
        Download UNITEN Fees Table (local)
          <FaArrowRightLong  className='ml-1 shrink-0'/>
        </a>
        <a
          href={scholarshipAndAidDownload}
           target='_blank'
          rel='noreferrer'
          download={scholarshipAndAidDownload}
          className='flex gap-1 text-center border  border-blue-700 text-blue-700 justify-center font-bold items-center p-2 px-3 2xl:text-[16px] 2xl:leading-7 rounded  w-full text-xs sm:whitespace-nowrap'
        >
          Download UNITEN Fees Table (international)
          <FaArrowRightLong className='ml-1 shrink-0' />
        </a>
        <Link
          to={"/scholarships"}
         
          className='flex gap-1 text-center border  border-blue-700 text-blue-700 justify-center font-bold items-center p-2 px-3 2xl:text-[16px] 2xl:leading-7 rounded  w-full text-xs sm:whitespace-nowrap'
        >
          View Scholarship & Financial Aid
          <FaArrowRightLong  className='ml-1 shrink-0'/>
        </Link>
      </div>
    </div>
  )
}
NextIntake.propTypes = {
  date: PropTypes.string,
  brochure: PropTypes.string,
  feeTable: PropTypes.string,
  scholarshipAndAidDownload: PropTypes.string
}
export default NextIntake
